<section>
    <h2>Instructions</h2>

    <div>
        <ul>
            <li>
                <span>1.</span>
                <p>
                    <strong>Beat the eggs:</strong>
                    In a bowl, beat the eggs with a pinch of salt and pepper until they are well mixed. You can add a tablespoon of water or milk for a fluffier texture.
                </p>
            </li>
            <li>
                <span>2.</span>
                <p>
                    <strong>Heat the pan:</strong>
                    Place a non-stick frying pan over medium heat and add butter or oil.
                </p>
            </li>
            <li>
                <span>3.</span>
                <p>
                    <strong>Cook the omelette:</strong>
                    Once the butter is melted and bubbling, pour in the eggs. Tilt the pan to ensure the eggs evenly coat the surface.
                </p>
            </li>
            <li>
                <span>4.</span>
                <p>
                    <strong>Add fillings (optional):</strong>
                    When the eggs begin to set at the edges but are still slightly runny in the middle, sprinkle your chosen fillings over one half of the omelette.
                </p>
            </li>
            
            <li>
                <span>5.</span>
                <p>
                    <strong>Fold and serve:</strong>
                    As the omelette continues to cook, carefully lift one edge and fold it over the fillings. Let it cook for another minute, then slide it onto a plate.
                </p>
            </li>
            
            <li>
                <span>6.</span>
                <p>
                    <strong>Enjoy:</strong>
                    Serve hot, with additional salt and pepper if needed.
                </p>
            </li>
        </ul>
    </div>
</section>


<style>
    section{
        padding-bottom: 1.5em;
        border-bottom: 1px solid var(--neu-light-grey);
    }
    h2{
        margin-block: 1em;
        margin-bottom: .5em;
        font-size: 1.75rem;
    }
    div{
        margin-block: 1em;
    }
    li{
        list-style-type: none;
        display: flex;
        gap: 1.3em;
        padding-left: 1em;
        margin-bottom: 1em;
    }

    li span{
        font-weight: bold;
        color: var(--primary-nutmeg)
    }


</style>